export const appointmentWithDataOptions = [
  {
    value: "Customer",
    lable: "Customer",
  },
  // {
  //   value: "Vendor",
  //   lable: "Vendor",
  // },
  {
    value: "Prospect",
    lable: "Prospect",
  },
  {
    value: "Others",
    lable: "Others",
  },
];

export const customerData = [
  {
    value: "Customer1",
    lable: "Customer1",
  },
  {
    value: "Customer2",
    lable: "Customer2",
  },
];

export const vendorData = [
  {
    value: "Vendor1",
    lable: "Vendor1",
  },
  {
    value: "Vendor2",
    lable: "Vendor3",
  },
];

export const leadData = [
  {
    value: "Lead & Prospect1",
    lable: "Lead & Prospect1",
  },
  {
    value: "Lead & Prospect2",
    lable: "Lead & Prospect2",
  },
];
